<template>
	<div
		:class="[
			'text-gray-700 focus-within:text-orange-500',
			markInvalid ? 'text-red-500' : '',
		]"
	>
		<div class="flex justify-between flex-wrap">
			<label class="block font-medium" :for="inputId" v-if="!noLabel">
				{{ __(label) }}
				<ui-tooltip
					v-if="tooltipText"
					class="text-green-400"
					:icon-stroke-width="2"
					icon-class="ml-1 w-4 h-4"
					:text="__(tooltipText)"
				/>
			</label>
			<span class="text-red-500" v-if="markInvalid">{{
				validationMessage
			}}</span>
			<span class="text-gray-500" v-else-if="!required">optional</span>
		</div>
		<div
			class="mt-1 relative"
			:class="[
				'border border-gray-300 rounded-lg shadow-sm overflow-hidden focus-within:text-gray-900 focus-within:border-orange-500 focus-within:ring-1 focus-within:ring-orange-500',
				markInvalid
					? 'text-red-500 border-red-500 shadow-sm focus:text-gray-900'
					: '',
			]"
		>
			<ui-textarea
				:id="inputId"
				:rows="rows"
				v-model="val"
				class="block w-full py-2 border-0 resize-none focus:ring-0 -m-px"
				:class="maxWProse ? 'max-w-prose' : ''"
			>
			</ui-textarea>
		</div>
	</div>
</template>

<script>
import UiInputGroup from "./InputGroup.vue";
export default {
	mixins: [UiInputGroup],
	props: {
		type: {
			type: String,
			default: "textarea",
		},
		tooltipText: {
			type: String,
			default: "",
		},
		noLabel: {
			type: Boolean,
			default: false,
		},
		rows: {
			type: Number,
			default: 1,
		},
		maxWProse: {
			type: Boolean,
			default: true,
		},
	},
};
</script>
